import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { Product } from "@/types";
import { Link } from "@inertiajs/react";

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {

  return (
    <Card className="group overflow-hidden transition-shadow hover:shadow-lg">
      <CardContent className="p-0">
        <Link href={`/products/${product.id}`}>
          <div className="relative aspect-square overflow-hidden bg-secondary">
            <img
              src={product.primary_image || "/placeholder.svg"}
              alt={product.name}
              className="object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <Badge className="absolute right-2 top-2 bg-card text-card-foreground">
              {product.category}
            </Badge>
          </div>
        </Link>

        <div className="p-4">
          <h3 className="mb-2 line-clamp-2 font-medium text-pretty leading-snug">
            {product.name}
          </h3>

          <div className="mb-3 flex items-baseline gap-2">
            <span className="text-md text-foreground">
              Cena katalogowa:{" "}
              <span className="font-bold">{product.price.toFixed(2)} zł</span>
            </span>
          </div>
          {!!product.min_price && (
            <div className="mb-3 flex items-baseline gap-2">
              <span className="text-md text-foreground">
                Cena po zalogowaniu:{" "}
                <span className="font-bold">
                  {product.min_price.toFixed(2)} zł
                </span>
              </span>
            </div>
          )}
          {!!product.special_price && (
            <div className="mb-3 flex flex-col items-baseline gap-2">
              <span className="text-md text-foreground">
                Cena specjalna:{" "}
                <span className="font-bold">
                  {product.special_price.toFixed(2)} zł
                </span>
              </span>
              {!!product.special_price_conditions && (
                <span className="text-xs text-foreground">
                  {product.special_price_conditions}
                </span>
              )}
            </div>
          )}

          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <div className="size-2 rounded-full bg-accent" />
            <span>{product.store}</span>
          </div>
        </div>
      </CardContent>
      <CardFooter className="p-4 pt-0 pb-0">
        <a
          className="w-full gap-2 bg-transparent cursor-pointer"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            className="w-full gap-2 bg-transparent cursor-pointer"
            variant="outline"
          >
            <Link className="w-full gap-2 bg-transparent cursor-pointer" href="/lists/add_product_to_list" method="post" as="div" data={{ product_id: product.id }}>
              Dodaj do listy
            </Link>
          </Button>
        </a>
      </CardFooter>
      <CardFooter className="p-4 pt-0">
        <a
          href={product.link}
          className="w-full gap-2 bg-transparent cursor-pointer"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            className="w-full gap-2 bg-transparent cursor-pointer"
            variant="outline"
          >
            Zobacz w sklepie
            <ExternalLink className="size-4" />
          </Button>
        </a>
      </CardFooter>
    </Card>
  );
}
